export default [
  {
    path: '/contentManage/contentPool',
    name: 'contentPool',
    meta: {
      title: '内容池'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/contentPool/main.vue'], resolve)
    }
  },
  {
    path: '/contentManage/subscripeSource',
    name: 'subscripeSource',
    meta: {
      title: '订阅内容源'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/subscripeSource/main.vue'], resolve)
    }
  },
  {
    path: '/contentManage/setSource',
    name: 'setSource',
    meta: {
      title: '添加内容源'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/subscripeSource/setSource.vue'], resolve)
    }
  },
  {
    path: '/contentManage/editSource',
    name: 'editSource',
    meta: {
      title: '内容源编辑'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/subscripeSource/edit.vue'], resolve)
    }
  },
  {
    path: '/contentManage/internetStarSource',
    name: 'internetStarSource',
    meta: {
      title: '网红商品源'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/internetStarSource/main.vue'], resolve)
    }
  },
  {
    path: '/contentManage/internetStarSourceEdit',
    name: 'internetStarSourceEdit',
    meta: {
      title: '网红商品源编辑'
    },
    component(resolve) {
      require(['COMPONENTS/contentManage/internetStarSource/edit.vue'], resolve)
    }
  },
]